import { render, staticRenderFns } from "./Neskladja.vue?vue&type=template&id=5b360b82&"
import script from "./Neskladja.vue?vue&type=script&lang=js&"
export * from "./Neskladja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports